import React from 'react';
import { BookOpen, ClipboardCheck, FileText, FolderOpen, Gift, BookMarked } from 'lucide-react';
export function PackContentsSection() {
  return <section className="relative py-20 px-4 bg-gradient-to-br from-[#E91E63] via-[#AB47BC] to-[#00BCD4]" data-id="element-57">
      {/* Subtle overlay for depth */}
      <div className="absolute inset-0 bg-black/10 pointer-events-none" data-id="element-58"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-59">
        <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-60">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 drop-shadow-md" data-id="element-61">
            ¿Qué vas a encontrar dentro del MegaPack?
          </h2>
          <p className="text-lg text-white/90" data-id="element-62">
            Todo lo que necesitás para la intensificación, listo para usar desde
            el primer día.
          </p>
        </div>

        {/* 4 Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-63">
          <div className="bg-white rounded-2xl p-8 shadow-lg flex items-start gap-5" data-id="element-64">
            <div className="bg-cyan-50 p-3 rounded-xl flex-shrink-0" data-id="element-65">
              <BookOpen className="w-8 h-8 text-[#00BCD4]" data-id="element-66" />
            </div>
            <div data-id="element-67">
              <h3 className="text-xl font-bold text-[#1A1A1A] mb-2" data-id="element-68">
                📚 8 Materias Completas
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-69">
                Lengua y Literatura, Matemática, Ciencias Naturales, Ciencias
                Sociales, Inglés, Educación Física, Educación Artística y
                Construcción de la Ciudadanía.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg flex items-start gap-5" data-id="element-70">
            <div className="bg-rose-50 p-3 rounded-xl flex-shrink-0" data-id="element-71">
              <ClipboardCheck className="w-8 h-8 text-[#E91E63]" data-id="element-72" />
            </div>
            <div data-id="element-73">
              <h3 className="text-xl font-bold text-[#1A1A1A] mb-2" data-id="element-74">
                📋 Instrumentos de Evaluación
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-75">
                Rúbricas y planillas de seguimiento oficiales.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg flex items-start gap-5" data-id="element-76">
            <div className="bg-cyan-50 p-3 rounded-xl flex-shrink-0" data-id="element-77">
              <FileText className="w-8 h-8 text-[#00BCD4]" data-id="element-78" />
            </div>
            <div data-id="element-79">
              <h3 className="text-xl font-bold text-[#1A1A1A] mb-2" data-id="element-80">
                📄 Guías de Actividades
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-81">
                Listas para imprimir y fotocopiar.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg flex items-start gap-5" data-id="element-82">
            <div className="bg-rose-50 p-3 rounded-xl flex-shrink-0" data-id="element-83">
              <FolderOpen className="w-8 h-8 text-[#E91E63]" data-id="element-84" />
            </div>
            <div data-id="element-85">
              <h3 className="text-xl font-bold text-[#1A1A1A] mb-2" data-id="element-86">
                📁 Documentación de Respaldo
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-87">
                Normativa explicada para tu carpeta docente.
              </p>
            </div>
          </div>
        </div>

        {/* Bonuses Section */}
        <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-white/20 text-center" data-id="element-88">
          <div className="inline-flex items-center justify-center gap-2 mb-8" data-id="element-89">
            <Gift className="w-6 h-6 text-white" data-id="element-90" />
            <h3 className="text-2xl font-bold text-white" data-id="element-91">
              🎁 Además incluye{' '}
              <span className="text-[#B3E5FC]" data-id="element-92">3 Bonos Especiales</span>
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-93">
            <div className="bg-white/15 backdrop-blur-sm rounded-xl p-6 border border-white/20 flex flex-col items-center gap-3" data-id="element-94">
              <BookMarked className="w-10 h-10 text-[#E91E63]" data-id="element-95" />
              <p className="font-bold text-white text-lg" data-id="element-96">Ciudadanía Digital</p>
            </div>
            <div className="bg-white/15 backdrop-blur-sm rounded-xl p-6 border border-white/20 flex flex-col items-center gap-3" data-id="element-97">
              <BookMarked className="w-10 h-10 text-[#00BCD4]" data-id="element-98" />
              <p className="font-bold text-white text-lg" data-id="element-99">
                Educación Sexual Integral
              </p>
            </div>
            <div className="bg-white/15 backdrop-blur-sm rounded-xl p-6 border border-white/20 flex flex-col items-center gap-3" data-id="element-100">
              <BookMarked className="w-10 h-10 text-[#9C27B0]" data-id="element-101" />
              <p className="font-bold text-white text-lg" data-id="element-102">
                Educación Ambiental
              </p>
            </div>
          </div>

          <p className="text-white/80 italic text-lg" data-id="element-103">
            Para una propuesta pedagógica integral.
          </p>
        </div>
      </div>
    </section>;
}